export const COURSES = {
    GETALL_COURSES_REQUEST: "GETALL_COURSES_REQUEST",
    GETALL_COURSES_SUCCESS: "GETALL_COURSES_SUCCESS",
    GETALL_COURSES_FAILURE: "GETALL_COURSES_FAILURE",

    CREATE_COURSES_REQUEST: "CREATE_COURSES_REQUEST",
    CREATE_COURSES_SUCCESS: "CREATE_COURSES_SUCCESS",
    CREATE_COURSES_FAILURE: "CREATE_COURSES_FAILURE",

    DELETE_COURSES_REQUEST: "DELETE_COURSES_REQUEST",
    DELETE_COURSES_SUCCESS: "DELETE_COURSES_SUCCESS",
    DELETE_COURSES_FAILURE: "DELETE_COURSES_FAILURE",

    CREATE_MAIN_COURSES_REQUEST: "CREATE_MAIN_COURSES_REQUEST",
    CREATE_MAIN_COURSES_SUCCESS: "CREATE_MAIN_COURSES_SUCCESS",
    CREATE_MAIN_COURSES_FAILURE: "CREATE_MAIN_COURSES_FAILURE",

    GET_COURSES_DETAIL_REQUEST: "GET_COURSES_DETAIL_REQUEST",
    GET_COURSES_DETAIL_SUCCESS: "GET_COURSES_DETAIL_SUCCESS",
    GET_COURSES_DETAIL_FAILURE: "GET_COURSES_DETAIL_FAILURE",

    CREATE_CONTENT_SECTION_REQUEST: "CREATE_CONTENT_SECTION_REQUEST",
    CREATE_CONTENT_SECTION_SUCCESS: "CREATE_CONTENT_SECTION_SUCCESS",
    CREATE_CONTENT_SECTION_FAILURE: "CREATE_CONTENT_SECTION_FAILURE",

    UPDATE_SECTION_REQUEST: "UPDATE_SECTION_REQUEST",
    UPDATE_SECTION_SUCCESS: "UPDATE_SECTION_SUCCESS",
    UPDATE_SECTION_FAILURE: "UPDATE_SECTION_FAILURE",

    UPDATE_CONTENT_SECTION_REQUEST: "UPDATE_CONTENT_SECTION_REQUEST",
    UPDATE_CONTENT_SECTION_SUCCESS: "UPDATE_CONTENT_SECTION_SUCCESS",
    UPDATE_CONTENT_SECTION_FAILURE: "UPDATE_CONTENT_SECTION_FAILURE",

    DRAG_SECTION_REQUEST: "DRAG_SECTION_REQUEST",
    DRAG_SECTION_SUCCESS: "DRAG_SECTION_SUCCESS",
    DRAG_SECTION_FAILURE: "DRAG_SECTION_FAILURE",

    DELETE_CONTENT_REQUEST: "DELETE_CONTENT_REQUEST",
    DELETE_CONTENT_SUCCESS: "DELETE_CONTENT_SUCCESS",
    DELETE_CONTENT_FAILURE: "DELETE_CONTENT_FAILURE",

    DELETE_SUBSECTION_REQUEST: "DELETE_SUBSECTION_REQUEST",
    DELETE_SUBSECTION_SUCCESS: "DELETE_SUBSECTION_SUCCESS",
    DELETE_SUBSECTION_FAILURE: "DELETE_SUBSECTION_FAILURE",
  };